<template>
  <input type="hidden" :name="name" :value="value" />
</template>

<script lang="ts">
export type HiddenFieldProps = {
  name: string;
  modelValue?: string | number | boolean | null;
};
</script>

<script lang="ts" setup>
import { useField } from "vee-validate";

const props = defineProps<HiddenFieldProps>();

const { value } = useField<string | number | boolean | null | undefined>(
  () => props.name,
  undefined,
  {
    syncVModel: true,
  }
);
</script>
